<!-- This is an example component -->
 <section class="w-full  flex flex-col">
    <div class="w-full p-6 relative h-[400px] bg-cover  bg-no-repeat bg-center flex flex-col justify-center "  style="background-image: url('https://imageio.forbes.com/specials-images/dam/imageserve/1160708824/0x0.jpg?format=jpg&height=900&width=1600&fit=bounds');">
        <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
        <!-- <h1 class="z-10  text-7xl text-left text-white text-shadow font-extrabold uppercase "> {{view.page?.content.name}} </h1> -->
        <h1 class="z-10  text-7xl text-left text-white text-shadow font-extrabold uppercase border-b-2 border-primary-700 max-w-128">Brochures</h1>

    </div>
    <div class="w-full grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 gap-4 md:gap-8 lg:gap-8 p-4 md:p-8 lg:p-16 xl:p-16">
        <!-- @for(blog of view.blogs; track blog) { -->
        <fuse-card  class="flex flex-col bg-white shadow-md border shadow-lg border-gray-200  ">
            <div class=" h-80 border-t-4 border-primary-500">
                <img src="https://whitestar.co.za/wp-content/uploads/2024/08/WS_Seabourn-Expedition-Calendar-Sept-24-March-26.jpg">
            </div>
            <div class=" flex flex-col p-4 bg-accent-500 text-white">
                <h1 class="text-center">
                    Seabourn Venture & Seabourn Pursuit: September 2024 – March 2026
                </h1>
                <button class="mt-2 p-2 bg-primary-500 uppercase">download</button>
            </div>
        </fuse-card>
        <fuse-card  class="flex flex-col bg-white shadow-md border shadow-lg border-gray-200  ">
            <div class=" h-80 border-t-4 border-primary-500">
                <img src="https://whitestar.co.za/wp-content/uploads/2024/08/WS_Seabourn-Expedition-Calendar-Sept-24-March-26.jpg">
            </div>
            <div class=" flex flex-col p-4 bg-accent-500 text-white">
                <h1 class="text-center">
                    Seabourn Venture & Seabourn Pursuit: September 2024 – March 2026
                </h1>
                <button class="mt-2 p-2 bg-primary-500 uppercase">download</button>
            </div>
        </fuse-card>
        <fuse-card  class="flex flex-col bg-white shadow-md border shadow-lg border-gray-200  ">
            <div class=" h-80 border-t-4 border-primary-500">
                <img src="https://whitestar.co.za/wp-content/uploads/2024/08/WS_Seabourn-Expedition-Calendar-Sept-24-March-26.jpg">
            </div>
            <div class=" flex flex-col p-4 bg-accent-500 text-white">
                <h1 class="text-center">
                    Seabourn Venture & Seabourn Pursuit: September 2024 – March 2026
                </h1>
                <button class="mt-2 p-2 bg-primary-500 uppercase">download</button>
            </div>
        </fuse-card>
        <fuse-card  class="flex flex-col bg-white shadow-md border shadow-lg border-gray-200  ">
            <div class=" h-80 border-t-4 border-primary-500">
                <img src="https://whitestar.co.za/wp-content/uploads/2024/08/WS_Seabourn-Expedition-Calendar-Sept-24-March-26.jpg">
            </div>
            <div class=" flex flex-col p-4 bg-accent-500 text-white">
                <h1 class="text-center">
                    Seabourn Venture & Seabourn Pursuit: September 2024 – March 2026
                </h1>
                <button class="mt-2 p-2 bg-primary-500 uppercase">download</button>
            </div>
        </fuse-card>
        <fuse-card  class="flex flex-col bg-white shadow-md border shadow-lg border-gray-200  ">
            <div class=" h-80 border-t-4 border-primary-500">
                <img src="https://whitestar.co.za/wp-content/uploads/2024/08/WS_Seabourn-Expedition-Calendar-Sept-24-March-26.jpg">
            </div>
            <div class=" flex flex-col p-4 bg-accent-500 text-white">
                <h1 class="text-center">
                    Seabourn Venture & Seabourn Pursuit: September 2024 – March 2026
                </h1>
                <button class="mt-2 p-2 bg-primary-500 uppercase">download</button>
            </div>
        </fuse-card>
        <fuse-card  class="flex flex-col bg-white shadow-md border shadow-lg border-gray-200  ">
            <div class=" h-80 border-t-4 border-primary-500">
                <img src="https://whitestar.co.za/wp-content/uploads/2024/08/WS_Seabourn-Expedition-Calendar-Sept-24-March-26.jpg">
            </div>
            <div class=" flex flex-col p-4 bg-accent-500 text-white">
                <h1 class="text-center">
                    Seabourn Venture & Seabourn Pursuit: September 2024 – March 2026
                </h1>
                <button class="mt-2 p-2 bg-primary-500 uppercase">download</button>
            </div>
        </fuse-card>
    <!-- } -->
    </div>
    <app-footer-type03></app-footer-type03>

</section>